import { Link, useNavigate } from 'react-router';
import { TopBar } from '../components/ui';
import { useT } from '../i18n';

const FAQ: [string, string][] = [
  ['Are coins real money?', 'No. Coins are virtual, have no cash value and can never be withdrawn, sold or transferred between players. They exist only to play games for fun.'],
  ['How do I get more coins?', 'Claim the daily reward, complete missions and achievements, watch optional rewarded videos, invite friends, or play well! You can also buy coin packs in the store where available.'],
  ['What happens if my connection drops?', 'Your seat is kept for you. Reconnect within the grace period and you continue exactly where you left off. If you miss turns, the game plays a safe move for you, and after a while the game keeps playing for you until you return.'],
  ['Is the shuffle fair?', 'Cards are shuffled on our servers with a cryptographically secure random generator — your device never decides the cards. We run statistical fairness tests continuously.'],
  ['How do private rooms work?', 'Create a room, share the 6-character code, link or QR with friends, and start when everyone has joined.'],
  ['How do I report someone?', 'Open their profile and tap Report. Our moderators review every report. You can also block players so they cannot message or invite you.'],
  ['Can I delete my account?', 'Yes — Settings → Delete account. Your personal data is erased; anonymised financial records are kept for auditing as required.'],
];

export function Help() {
  const t = useT();
  const nav = useNavigate();
  return (
    <main className="page">
      <TopBar title={t('help.title')} onBack={() => nav(-1)} />
      <h2 className="section-title">{t('lobby.howToPlay')}</h2>
      <div className="row wrap">
        {(['CALL_BREAK', 'SPADES', 'TARNEEB', 'HEARTS', 'FIVE_HUNDRED', 'JUDGEMENT', 'RUMMY', 'EUCHRE', 'GIN_RUMMY', 'TWENTY_NINE', 'CRAZY_EIGHTS', 'CRIBBAGE', 'BLACKJACK', 'BHABHI', 'PINOCHLE', 'ANDAR_BAHAR', 'BRIDGE', 'SEVENS', 'SCOPA', 'BACCARAT', 'BLUFF', 'DRAGON_TIGER', 'FLUSH', 'COURT_PIECE', 'DEHLA_PAKAD', 'WHIST', 'SEEP', 'BELOTE', 'DURAK', 'PRESIDENT', 'BRISCOLA', 'CASINO_WAR', 'THREE_CARD_POKER', 'GO_FISH', 'TRESSETTE', 'RED_DOG', 'CANASTA', 'SKAT', 'PAI_GOW', 'BIG_TWO', 'WAR', 'RUMMY_500', 'BRAG', 'PITCH', 'HAZARI', 'TEEN_PATTI', 'POKER', 'MARRIAGE'] as const).map((g) => (
          <Link key={g} className="btn" to={`/tutorial/${g}`}>{t(`game.${g}`)}</Link>
        ))}
      </div>
      <h2 className="section-title">FAQ</h2>
      <div className="col">
        {FAQ.map(([q, a]) => (
          <details key={q} className="card">
            <summary style={{ fontWeight: 700, cursor: 'pointer', minHeight: 32 }}>{q}</summary>
            <p className="dim" style={{ marginBottom: 0 }}>{a}</p>
          </details>
        ))}
      </div>
      <h2 className="section-title">Contact</h2>
      <p className="dim">Need help with a purchase or your account? Email <a href="mailto:support@myacademiahub.com">support@myacademiahub.com</a> with your username.</p>
      <p className="muted" style={{ fontSize: 'var(--fs-xs)' }}>{t('settings.legal')} Teen Patti and Poker are social casino games for entertainment only (17+).</p>
    </main>
  );
}
